//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";
export const POST_STREAMER_REGISTER = "/streamer/register";
export const GET_REMEMBER_PASSWORD = "/streamer/remember_pass";
export const POST_FORGOT_PASSWORD = "/streamer/remember-password";
//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const POST_LOGIN = "/streamer/login";

//PROFILE
export const GET_STREAMER_PROFILE = "/streamer/profile";
export const GET_STREAMER_STATUS = "/streamer/status/{streamerID}";
export const POST_STREAMER_IMAGE = "/streamer/update/image";

export const GET_STREAMER_KPI = '/streamer/campaigns/subscriptions/kpi'

export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

export const POST_BILLING_PROFILE = "/streamer/update/billing";
export const POST_CONTACT_PROFILE = "/streamer/update/contact";
export const POST_PROFILE = "/streamer/update/profile";
export const POST_PLAYOUT = "/streamer/update/playout";

export const POST_AUTOMATIC_CAMPAIGNS = '/'
export const POST_STREAMER_LEAVE = '/streamer/leave'

//CAMPAIGNS
export const GET_STREAMER_CAMPAIGNS = "/streamer/campaigns";
export const GET_STREAMER_SUSCRIBER_CAMPAIGNS = "/streamer/campaigns/subscriptions";
export const POST_STREAMER_SUBSCRIBER_STATUS = "/streamer/campaigns/subscriptions/update";
export const POST_STREAMER_SUBSCRIBE_CAMPAIGN = "/streamer/campaigns/subscribe";

//STATISTICS
export const GET_STREAMER_STATISTICS = "/streamer/statistics";
export const GET_STREAMER_SUMMARY = "/streamer/analytics/summary";
export const GET_STREAMER_DAILY = "/streamer/analytics/daily";

//WALLET
export const GET_WALLET_ACTIVITY = "/streamer/wallet/activity";
export const GET_ACTUAL_BALLANCE = "/streamer/wallet";
export const POST_WITHDRAW_BALLANCE = "/streamer/wallet/withdrawal";
export const GET_WALLET_BY_CAMPAIGN = "/streamer/wallet/by-campaigns";
export const GET_WALLET_INVOICES = "/streamer/wallet/report/invoices";

//TWITCH
export const GET_URL_REDIRECT_TWITCH_AUTH = `/social-auth/twitch/initiate?result-url=${ encodeURIComponent(process.env.REACT_APP_TWITCH_AUTH_RESULT_URL ?? '') }&redirect=false`;

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//Mails
export const GET_INBOX_MAILS = "/inboxmails";
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//KANBANBOARDS
export const GET_KANBANBOARDS = "/kanban-board";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";
